<template>
  <Modal v-model="show" title="Entendendo seu nível">
    <div class="modal-proficiency-level-explanation-title">
      Seu caminho no inglês
    </div>
    <div class="modal-proficiency-level-explanation-description">
      Os níveis de proficiência em inglês seguem o CEFR (Quadro Europeu Comum de
      Referência para Línguas), ajudando você a entender seu progresso no
      aprendizado
    </div>

    <div class="modal-proficiency-level-explanation-list">
      <div
        v-for="level in levelsExplanations"
        :key="level.level"
        class="modal-proficiency-level-explanation-item"
      >
        <div class="modal-proficiency-level-explanation-item-title">
          {{ level.level }}
        </div>
        <div class="modal-proficiency-level-explanation-item-text">
          {{ level.text }}
        </div>
      </div>
    </div>
  </Modal>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue';

import Modal from '@/components/Modal/index.vue';

const props = defineProps<{
  modelValue: boolean;
}>();

const show = ref(props.modelValue);
const $emit = defineEmits(['update:modelValue']);

watch(
  () => show.value,
  () => {
    $emit('update:modelValue', show.value);
  },
);

watch(
  () => props.modelValue,
  () => {
    show.value = props.modelValue;
  },
);

const levelsExplanations = ref([
  {
    level: 'A0 - Pronto para aprender',
    text: 'Está pronto para começar a aprender',
  },
  {
    level: 'A1 - Iniciante',
    text: 'Entende e usa expressões simples',
  },
  {
    level: 'A2 - Básico',
    text: 'Compreende frases cotidianas e interage em situações simples',
  },
  {
    level: 'B1 - Intermediário',
    text: 'Entende tópicos gerais, conversa sobre interesses e lida com situações mais comuns em viagens.',
  },
  {
    level: 'B2 - Intermediário Avançado',
    text: 'Se comunica com clareza sobre temas mais complexos e trabalha ou estuda em inglês.',
  },
  {
    level: 'C1 - Avançado',
    text: 'Tem fluência para discutir ideias complexas, escreve bem e compreende textos técnicos',
  },
  {
    level: 'C2 - Proficiente',
    text: 'Domina o idioma em qualquer contexto, como um falante nativo.',
  },
]);
</script>
<style scoped>
.modal-proficiency-level-explanation-title {
  font-size: 24px;
  font-weight: 500;
  line-height: 120%;
  color: var(--color-neutral-05);
  margin-top: 24px;
}

.modal-proficiency-level-explanation-description {
  font-size: 16px;
  line-height: 150%;
  color: var(--color-neutral-05);
}

.modal-proficiency-level-explanation-item {
  border-bottom: 1px solid var(--color-neutral-02);
  padding-top: 16px;
  padding-bottom: 16px;
}

.modal-proficiency-level-explanation-list {
  margin-top: 24px;
}

.modal-proficiency-level-explanation-item-title {
  font-size: 16px;
  color: var(--color-neutral-06);
  font-weight: 500;
  line-height: 136%;
}

.modal-proficiency-level-explanation-item-text {
  font-size: 14px;
  color: var(--color-neutral-05);
}

.modal-proficiency-level-explanation-item:last-child {
  border-bottom: none;
}
</style>
